/**
 *
 * @param features - object of plan features
 * @param planFeatures - plan features array
 * @returns Array of table data to render
 */
export const getTableData = (
  features: IPlanFeatureValue[],
  planFeatures: IPlanFeatureConfig[]
) => {
  return planFeatures.map(({ featureMasterID, featureTitle }) => {
    const featureValue = features?.find(
      (item) => item.featureMasterID === featureMasterID
    )?.productFeatureValue;

    return {
      featureMasterID,
      title: featureTitle,
      value: featureValue,
    };
  });
};
